module.exports = __webpack_public_path__ + "img/08.49204dd2.png";